(ns measure.reporting-ocp.view.tabs.delivery
  (:require ["@mui/material/Autocomplete$default" :as Autocomplete]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Switch$default" :as Switch]
            ["@mui/material/TextField$default" :as TextField]
            [clojure.string :as str]
            [common.util :refer [spread-props]]
            [common.widgets.form-field :refer [form-field]]
            [measure.reporting-ocp.db.core :as form]
            [measure.reporting-ocp.db.options :as options]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]))

(defui send-emails-field []
  (let [send-emails? (:value (form/use-bind-control [:send-emails?]))]
    ($ form-field
       {:label "Send reports via e-mail"}
       ($ Stack {:direction "row" :gap 1}
          ($ Switch
             {:checked send-emails?
              :onChange #(rf/dispatch [:form.report/on-change-send-emails? :send-emails? (not send-emails?)])})
          (if send-emails? "On" "Off")))))

(defui recipients-field []
  (let [{:keys [error on-change value] :as control} (form/use-bind-control [:email])
        option->label (fn [option]
                        (if (map? option)
                          (:label option)
                          option))
        delivery-error-message (form/use-error-message [:delivery-valid?])
        email-error-message (form/use-error-message [:email])
        email-options (options/use-email-options)]
    ($ form-field
       {:label "Send report to"
        :err-msg (or delivery-error-message email-error-message)}
       ($ Autocomplete
          (spread-props control
                        {:value (to-array value)
                         :options (to-array email-options)
                         :multiple true
                         :freeSolo true
                         :size "small"
                         :getOptionLabel option->label
                         :getOptionKey (fn [option] (:value option))
                         :onChange (fn [_e ^js value] (on-change value))
                         :renderTags (fn dropdown-render-tags [^js value ^js get-tag-props]
                                       (map-indexed (fn [index ^js option]
                                                      ($ Chip (spread-props (get-tag-props #js {:index index})
                                                                            {:label (option->label option)})))
                                                    value))
                         :renderInput (fn [^js props]
                                        ($ TextField (spread-props props {:error error})))
                         :filterOptions (fn [^js options ^js state]
                                          (let [input (.toLowerCase (.-inputValue state))]
                                            (if-not (str/blank? input)
                                              (.filter options (fn [option]
                                                                 (or (str/includes? (str/lower-case (str (:value option))) input)
                                                                     (str/includes? (str/lower-case (:label option)) input))))
                                              options)))})))))

(defui delivery-tab []
  (let [send-emails? (:value (form/use-bind-control [:send-emails?]))]
    ($ :<>
       ($ send-emails-field)
       (when send-emails? ($ recipients-field)))))
